import {useTranslation} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {Assignment} from '@features/assignment/types'
import {
    ASSIGNMENT_CARD_SUBTITLE_CLASSNAME,
    ASSIGNMENT_CARD_TITLE_CLASSNAME,
    ASSIGNMENT_CARD_WRAPPER_CLASSNAME
} from '../constants'

export const AssignmentHostInstructionsCard: FC<{assignment: Assignment}> = ({assignment}) => {
    const {t} = useTranslation()

    return (
        <div className={ASSIGNMENT_CARD_WRAPPER_CLASSNAME}>
            <div className="flex flex-col gap-1">
                <h3 className={ASSIGNMENT_CARD_TITLE_CLASSNAME}>{t('assignment:host_instructions_card:title')}</h3>
                <p className={ASSIGNMENT_CARD_SUBTITLE_CLASSNAME}>{t('assignment:host_instructions_card:subtitle')}</p>
            </div>
            <div className="flex flex-col gap-1">
                <p className={`${ASSIGNMENT_CARD_SUBTITLE_CLASSNAME} whitespace-pre-line break-words`}>
                    {assignment.instructions}
                </p>
            </div>
        </div>
    )
}
